// White-label branding.
//
// When the app is served from an MDIS host (e.g. https://aits.mdis.in) we swap
// the default MyClassroom logos for the MDIS logo. Detection is by hostname:
// window.location.hostname is just the host ("aits.mdis.in") — no protocol and
// no path — so we match on that, NOT on the full URL.
import mdisLogo from "../assets/mdis/new-logo-mdis.png";

// Hosts whose domain contains "mdis.in" are treated as the MDIS white-label
// (covers aits.mdis.in and any future mdis.in subdomain). Add more brands here.
const isMdisHost = () => {
	if (typeof window === "undefined" || !window.location) return false;
	return window.location.hostname.toLowerCase().includes("mdis.in");
};

// True once per load when the current host is a white-labelled brand.
export const isWhiteLabel = isMdisHost();

// Returns the white-label logo when applicable, otherwise the caller's own
// default. Lets each component keep its existing logo import as the fallback:
//   <img src={brandLogo(myclassroom_logo)} />
export const brandLogo = (defaultLogo) => (isWhiteLabel ? mdisLogo : defaultLogo);

// The MDIS logo's wordmark is white, so it needs a coloured backdrop to stay
// legible on light headers. Spread into the logo <img> style; it's empty (a
// no-op) for the default brand:
//   <img src={brandLogo(logo)} style={{ ...existing, ...brandLogoStyle }} />
export const brandLogoStyle = isWhiteLabel ? { backgroundColor: "#06162f" } : {};
